import { useEffect } from "react"
import { useGeolocated } from "react-geolocated"

const AgentGeolocation=({setAgentCoords}:any)=>{
    const {coords} = useGeolocated({
        positionOptions: {
          enableHighAccuracy: false,
          maximumAge: 0,
          timeout: Infinity,
        },
        watchLocationPermissionChange: true,
      }) 

      useEffect(()=>{
        if(coords){
            setAgentCoords(coords)
        }
      })
      return(<div className="d-none"></div>)
}
export default AgentGeolocation